import { gql, useQuery } from '@apollo/client'
import { LineaTemplate } from 'components'
import { useEffect, useState } from 'react'
import { initializeApollo } from 'utils/apollo'
import { LINEA, LINEE, PREZZI_PRODOTTI } from 'utils/queries'
import { NextWrapper } from '../../data-fetching-wrapper'

function Detail({ linea, pagina }) {
  const { data: dataPrezzi, loading: loadingPrezzi } = useQuery(PREZZI_PRODOTTI, {
    variables: { idProdotti: linea.prodotti.map((p) => p.pk) },
  })

  const [lineaPrezzi, setLineaPrezzi] = useState(linea)

  useEffect(() => {
    if (!loadingPrezzi && dataPrezzi?.prezziProdotti?.length) {
      const prodotti = linea.prodotti.map((p) => {
        const current = dataPrezzi.prezziProdotti.find((x) => x.pk === p.pk)
        return { ...p, prezzoScontato: current.prezzoScontato }
      })
      setLineaPrezzi({ ...linea, prodotti })
    }
  }, [loadingPrezzi])

  return <LineaTemplate linea={lineaPrezzi} pagina={pagina} />
}

export async function getStaticPaths() {
  const client = initializeApollo()

  const {
    data: { linee },
  } = await client.query({
    query: LINEE,
  })

  const paths = linee.edges.map(({ node }) => ({
    params: { slug: node.chiave },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ params: { slug } }) => {
  const client = initializeApollo()

  const {
    data: { linea },
  } = await client.query({
    query: gql`
      ${LINEA.replace('__slug__', slug)}
    `,
  })

  if (!linea) {
    return {
      notFound: true,
    }
  }

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      query {
        pagina(chiave: "linea-detail", contentTypeId: ${linea.contentTypeId}, objectId: ${linea.pk}) {
          breadcrumbs {
            titolo
            url
          }
          seo {
            title
            description
            image
          }
          chiave
        }
      }
    `,
  })

  return {
    props: { linea, pagina, key: linea.pk },
    revalidate: 60 * 5,
  }
}, 'linee/[slug]')

export default Detail
